import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
      <strong><span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">Description</span></strong>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
        <span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">
            This action triggers the bottom 5 stowers with the highest stowed package opportunity missed. Where Stowed Package Opportunity Missed is equal to (Expected Rate - Actual Rate) * Hours. These associates have a minimum of 10 hours in
            path from prior week.
        </span>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
      <strong><span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">Impact</span></strong>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
        <span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">
            Sort to Container is a direct representation of production output quantifying the number of completed packages ready for a singular route. By having visibility on the bottom performers, this will have a direct impact on the number
            engagements that are conducted on a daily basis, therefore facilitating increased stow output. The action will direct the associate's Area Manager to immediately perform an audit for best practices effecting PPH and direct pick and
            stage rates.
        </span>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
      <strong><span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">Resolution Steps</span></strong>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
        <span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);" lang="EN-US">
            1) Confirm with Associate on blockers to productivity and confirm if retraining is needed<br />
            2) Close the action.
        </span>
    </p>
    <p style="margin-top: 0cm; margin-right: 0cm; margin-bottom: 7.5pt; margin-left: 0cm;">
      <strong><span style="background: white; font-size: 10.5pt; font-family: 'Helvetica', sans-serif; color: rgb(51, 51, 51);">Supplemental Links</span></strong>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_Stow_Productivity.jsx